import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import OchaIcon from "../components/OchaIcon";
import CarouselHome from "../components/CarouselHome";
import OrganizationInfo from "../components/OrganizationInfo";
import WorkDoneAreas from "../components/WorkDoneAreas";
import { MissionStatement } from "../components/Mission";
import IconStat from "../components/IconStat";
import PsgsProgrammes from "../components/PsgsProgrammes";
import FutureStrategicPlan from "../components/FutureStrategicPlan";
import { impactStoryThemes, impactStories } from "../data/impact-stories";

const Home = ({ darkMode }) => {
    return (
        <>
            <CarouselHome />
            <Container className={`home-container ${darkMode ? 'dark' : 'light'}`}>
                <div>
                    <OrganizationInfo />
                </div>
                <MissionStatement />
                <PsgsProgrammes />
                <IconStat />
                {/* <FutureStrategicPlan /> */}
                <div style={{ padding: '20px 0' }}>
                    <WorkDoneAreas />
                </div>

                {/* Training Center Section */}
                <div style={{ padding: '30px 0 20px' }}>
                    <h2 className="text-center mb-2" style={{ color: '#2E7D32' }}>Training Center</h2>
                    <p className="text-center mb-4" style={{ maxWidth: '800px', margin: '0 auto', fontSize: '1.05rem' }}>
                        PSGS operates a fully equipped residential Training Center at Kadepur, Sangli — an ideal venue
                        for trainings, conferences, and knowledge-sharing events.
                    </p>
                    <Row className="align-items-center g-4">
                        <Col md={7}>
                            <img
                                src="/traning_center.png"
                                alt="PSGS Training Center"
                                style={{ width: '100%', height: 'auto', borderRadius: '10px', boxShadow: '0 3px 12px rgba(0,0,0,0.12)' }}
                            />
                        </Col>
                        <Col md={5}>
                            <div style={{ padding: '10px 0' }}>
                                <div className="d-flex align-items-center mb-3">
                                    <OchaIcon name="Education" size={28} color="blue" style={{ marginRight: '8px' }} />
                                    <h5 style={{ margin: 0, color: '#2E7D32', fontWeight: '600' }}>Key Facilities</h5>
                                </div>
                                <ul style={{ lineHeight: '2', fontSize: '0.95rem', paddingLeft: '20px' }}>
                                    <li>Accommodation for 50 participants</li>
                                    <li>Conference hall for up to 500 people</li>
                                    <li>Two training halls & boardroom</li>
                                    <li>Kitchen & dining facility</li>
                                    <li>Open learning spaces</li>
                                </ul>
                                <Link
                                    to="/training-center"
                                    className="btn mt-2"
                                    style={{ backgroundColor: '#2E7D32', color: '#fff', borderRadius: '6px', padding: '8px 24px' }}
                                >
                                    Explore Training Center →
                                </Link>
                            </div>
                        </Col>
                    </Row>
                </div>

                {/* Our Impact Section */}
                <div style={{ padding: '30px 0 20px' }}>
                    <h2 className="text-center mb-2" style={{ color: '#2E7D32' }}>Our Impact</h2>
                    <p className="text-center mb-4" style={{ maxWidth: '800px', margin: '0 auto', fontSize: '1.05rem' }}>
                        Nearly two decades of transforming lives across rural Maharashtra through integrated
                        approaches to empowerment, conservation, and resilience.
                    </p>
                    <Row className="g-3">
                        {impactStoryThemes.slice(0, 3).map((theme) => {
                            const story = impactStories[theme.id];
                            return (
                                <Col md={4} key={theme.id}>
                                    <Card className="shadow-sm h-100" style={{
                                        backgroundColor: darkMode ? '#2c3034' : '#fff',
                                        border: darkMode ? '1px solid #495057' : '1px solid #e0e0e0',
                                        borderRadius: '10px',
                                        overflow: 'hidden'
                                    }}>
                                        <Card.Img
                                            variant="top"
                                            src={story.image}
                                            alt={theme.label}
                                            style={{ height: '160px', objectFit: 'cover' }}
                                        />
                                        <Card.Body>
                                            <Card.Title style={{ fontSize: '0.95rem', color: darkMode ? '#A5D6A7' : '#2E7D32', fontWeight: '600' }}>
                                                {theme.label}
                                            </Card.Title>
                                            <Card.Text style={{ fontSize: '0.85rem', color: darkMode ? '#ccc' : '#555' }}>
                                                {story.sections[0].content.substring(0, 120)}...
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            );
                        })}
                    </Row>
                    <div className="text-center mt-4">
                        <Link
                            to="/our-impact"
                            className="btn"
                            style={{ backgroundColor: '#2E7D32', color: '#fff', borderRadius: '6px', padding: '10px 30px', fontWeight: '500' }}
                        >
                            View All Impact Stories →
                        </Link>
                    </div>
                </div>
            </Container>
        </>
    );
};

export default Home;
